import $ from 'jquery';

function responsiveEmbeds() {
	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		
		// Bail if the element already has a responsive-embed parent or has the no-responsive class
		if( $(this).parent('.responsive-embed').length || $(this).hasClass('no-responsive') ) return false;
		
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} 
		else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});	
}

export { responsiveEmbeds };